import React, { Component } from 'react';
import RouteElementHeading from './RouteElementHeading';
import RouteElementContent from './RouteElementContent';

class RouteElement extends Component {
	render() {
		const { icon, title, summary, routeClick } = this.props;
		return <div 
			className = 'route_element pt-card pt-interactive'
			onClick = { routeClick }
		>
			<RouteElementHeading 
				icon = { icon }
			/>
			<RouteElementContent 
				title = { title }
				summary = { summary }
			/>
		</div>;
	}
}

export default RouteElement;


// WEBPACK FOOTER //
// ./src/components/home/RouteElement.jsx